import { render, staticRenderFns } from "./UserEditSegments.vue?vue&type=template&id=034b32e4&"
import script from "./UserEditSegments.vue?vue&type=script&lang=js&"
export * from "./UserEditSegments.vue?vue&type=script&lang=js&"
import style0 from "./UserEditSegments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports